import Button from 'components/button/Button';
import {
  Integration,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import { Alert, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import useEnableHostfullyDeviceModal from '../enableHostfullyDevicesModal/useEnableHostfullyDeviceModal';
import { ModalFooterStyled } from './ShareGuestInfoModal.styles';

const ShareGuestInfoModal = ({
  onConfirm,
  integration,
  modalId,
}: {
  integration: Integration;
  onConfirm: () => void;
  modalId: string;
}) => {
  const { t } = useTranslation();
  const { closeModal } = useAppModal();
  const { openEnableHostfullyDeviceModal } = useEnableHostfullyDeviceModal();

  const integrationName = integration.displayName ?? integration.name;

  const handleCloseModal = () => {
    closeModal(modalId);
  };

  const handleAccept = () => {
    // Show Hostfully Devices terms and conditions
    if (integration.enumId === IntegrationEnum.HOSTFULLYDEVICES) {
      closeModal(modalId);
      openEnableHostfullyDeviceModal({
        integration,
        onConfirm,
      });
      return;
    }

    onConfirm();
    handleCloseModal();
  };

  return (
    <div>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('pageIntegrations.modals.shareGuestInfo.title', {
            integration: integrationName,
          })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Alert bsStyle="danger">
          {t('pageIntegrations.modals.shareGuestInfo.description')}
        </Alert>
      </Modal.Body>

      <Modal.Footer>
        <ModalFooterStyled>
          <Button bsStyle="default" onClick={handleCloseModal}>
            {t('common.cancel')}
          </Button>

          <div>
            <Button className="decline-button" onClick={handleCloseModal}>
              {t('pageIntegrations.modals.shareGuestInfo.decline')}
            </Button>
            <Button className="accept-button" onClick={handleAccept}>
              {t('pageIntegrations.modals.shareGuestInfo.accept')}
            </Button>
          </div>
        </ModalFooterStyled>
      </Modal.Footer>
    </div>
  );
};

export default ShareGuestInfoModal;
